// Mirror of UK_RAIL_REGIONS in backend — used by frontend to derive a
// region slug from a vacancy's free-text location field.
const REGION_ALIASES = {
  london: ["london", "stratford", "kings cross", "king's cross", "paddington", "euston", "waterloo", "liverpool street", "victoria", "marylebone", "st pancras"],
  manchester: ["manchester", "salford", "stockport", "longsight", "newton heath"],
  birmingham: ["birmingham", "tyseley", "soho", "saltley", "wolverhampton"],
  glasgow: ["glasgow", "shields road", "yoker", "polmadie", "rutherglen"],
  edinburgh: ["edinburgh", "haymarket", "waverley", "millerhill"],
  leeds: ["leeds", "neville hill", "wakefield"],
  york: ["york", "holgate"],
  newcastle: ["newcastle", "gateshead", "heaton", "metrocentre", "north shields", "south shields"],
  liverpool: ["liverpool", "allerton", "edge hill", "bootle", "kirkby"],
  crewe: ["crewe", "alsager"],
  derby: ["derby", "etches park", "litchurch lane"],
  doncaster: ["doncaster", "doncaster carr"],
  swindon: ["swindon"],
  bristol: ["bristol", "st philips marsh", "filton"],
  cardiff: ["cardiff", "canton"],
  nottingham: ["nottingham"],
};

const REGION_NAMES = {
  london: "London", manchester: "Manchester", birmingham: "Birmingham",
  glasgow: "Glasgow", edinburgh: "Edinburgh", leeds: "Leeds", york: "York",
  newcastle: "Newcastle", liverpool: "Liverpool", crewe: "Crewe", derby: "Derby",
  doncaster: "Doncaster", swindon: "Swindon", bristol: "Bristol",
  cardiff: "Cardiff", nottingham: "Nottingham",
};

/** Derive { slug, name } from a vacancy's location string. Returns null if
 *  the location doesn't match any of our regional pages. */
export function regionFromLocation(text) {
  if (!text) return null;
  const lower = text.toLowerCase();
  for (const [slug, aliases] of Object.entries(REGION_ALIASES)) {
    if (aliases.some((a) => lower.includes(a))) {
      return { slug, name: REGION_NAMES[slug] };
    }
  }
  return null;
}
